import { RoleConfigStore } from '@hrms/common/store';
import React, { ReactNode, useEffect } from 'react';
import useUserPreferenceModal from './hooks/useUserPreferenceModal';
import { preferenceStore } from './store';

interface UserPreferenceComponentProps {
  children?: ReactNode;
}

const UserPreference: React.FC<UserPreferenceComponentProps> = ({
  children,
}) => {
  const { preference } = preferenceStore();

  const { openUserPreferenceModal, closeUserPreferenceModal } =
    useUserPreferenceModal();

  const { allowTenantSiteSelection } = RoleConfigStore((state) => state);
  const showPreferenceModal = allowTenantSiteSelection
    ? !preference?.selectedTenant?.id ||
      preference?.selectedSite?.id === undefined
    : false;

  useEffect(() => {
    if (!showPreferenceModal) return;
    openUserPreferenceModal({});
    return () => {
      closeUserPreferenceModal();
    };
  }, [showPreferenceModal]);

  if (showPreferenceModal) return null;

  return children;
};

export default UserPreference;
